import './abstract_section_view.coffee';# Added by Script 
Namespace('Monitoring.Reports.Executive')

class Monitoring.Reports.Executive.FansFollowersCompetence extends Monitoring.Reports.Executive.AbstractSectionView
  id: 'fans-followers'
  tagName: 'section'
  template: JST["backbone/templates/monitoring/reports/executive/fans_followers_competence"]

  initialize: (@options = {}) ->
    @colors = {}
    @colors[@options.settings.accountLabel.codes[0]] = @options.settings.accountLabel.color
    $.each @options.settings.competitorsLabels, (index, label) =>
      @colors[label.codes[0]] = label.color
    @brands = [@options.settings.accountLabel.codes[0]].concat (label.codes[0] for label in @options.settings.competitorsLabels)
    @brands_pages = []
    @brands_pages.push {code: @options.settings.accountLabel.codes[0], page: @options.settings.accountLabel.facebookPage, twitter_page: @options.settings.accountLabel.twitterPage}
    $.each @options.settings.competitorsLabels, (index, label) =>
      @brands_pages.push {code: label.codes[0], page: label.facebookPage, twitter_page: label.twitterPage}

    @social_networks = {
      fans: 
        description: "Facebook Fans"
        tag: "facebook_fans"
        ico: "facebook"
      followers: 
        description: "Twitter Followers"
        tag: "multiple_twitters_followers"
        ico: "twitter"
    }

  render: ->
    @$el.html(@template(socialNetworks: @social_networks))
    @bindChartsReady(2)
    @addFCount('facebook_fans')
    @addFCount('multiple_twitters_followers')
    return this

  addFCount: (socialNetwork) ->
    query = @extendedQuery({
      brands_pages: @brands_pages
      benchmark:
        date_from_ISO: @options.fromBenchmark.toISOString()
        date_to_ISO: @options.toBenchmark.toISOString()
    })
    #query['brands_pages'] = @brands_pages
    divId = "#bars-#{socialNetwork}"
    @_addHorizontalBars(query, divId, socialNetwork, {height: 300})